"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Media = void 0;
/**
 * A photo, video, or audio recording acquired or used in healthcare. The actual content may be inline or provided by direct reference.
 */
var Media = /** @class */ (function () {
    function Media() {
    }
    return Media;
}());
exports.Media = Media;
